/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import '../CSS/EstilosMenu.css'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/builder'
        icon='/media/icons/duotune/general/gen019.svg'
        title={intl.formatMessage({id: 'MENU.NEWS'})}
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {intl.formatMessage({id: 'MENU.MENU'})}
          </span>
        </div>
      </div>

      {/* ----Catalogo--- */}

      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        // title='Remesas'
        title={intl.formatMessage({id: 'MENU.CATALAGO'})}
        icon='/media/icons/duotune/general/gen022.svg'
        fontIcon='bi-person'
      >
        <div className=' menu-content-altura'>
          <SidebarMenuItem
            to='/menu/catalogo/usuarios'
            title={intl.formatMessage({id: 'CATALOGO.USUARIOS'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/tipodocumentos'
            title={intl.formatMessage({id: 'CATALOGO.TIPO_DOCUMENTOS'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/tipoproductofinanciero'
            title={intl.formatMessage({id: 'CATALOGO.TIPOPRODUCTOFINANCIERO'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/paises'
            title={intl.formatMessage({id: 'CATALOGO.PAISES'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/bancos'
            title={intl.formatMessage({id: 'CATALOGO.BANCO'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/constante'
            title={intl.formatMessage({id: 'CATALOGO.CONSTANTE'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/ocupacion'
            title={intl.formatMessage({id: 'CATALOGO.OCUPACION'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/moneda'
            title={intl.formatMessage({id: 'CATALOGO.MONEDA'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/roles'
            title={intl.formatMessage({id: 'CATALOGO.ROLES'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/workcenter'
            title={intl.formatMessage({id: 'CATALOGO.WORKCENTER'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/preguntas'
            title={intl.formatMessage({id: 'CATALOGO.PREGUNTAS'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/cuentasbancariasheo'
            title={intl.formatMessage({id: 'CATALOGO.CUENTASBANCARIASHEO'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/t100'
            title={intl.formatMessage({id: 'CATALOGO.T100'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/codigopromocional'
            title={intl.formatMessage({id: 'CATALOGO.PROMOCION'})}
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/menu/catalogo/canales'
            title={intl.formatMessage({id: 'CATALOGO.CANALES'})}
            hasBullet={true}
          />

          <SidebarMenuItem
            to='/menu/catalogo/horarioatencion'
            title='Horario Atencion'
            hasBullet={true}
          />

          {/* <SidebarMenuItem to='/menu/catalogo/remesasestatusprueba' title={intl.formatMessage({id: 'CATALOGO.REMESAS'})} hasBullet={true} />
        
        
         */}

          {/* <SidebarMenuItem to='/menu/catalogo/respuestas' title={intl.formatMessage({id: 'CATALOGO.RESPUESTAS'})} hasBullet={true} /> */}
        </div>
        {/* <SidebarMenuItem to='/menu/remesas/enviardinero' title='Enviar Dinero' hasBullet={true} /> */}
      </SidebarMenuItemWithSub>

      {/* ----TANDAS--- */}

      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        // title='Tandas'
        title={intl.formatMessage({id: 'MENU.OPERACION.TANDA'})}
        icon='/media/icons/duotune/general/gen025.svg'
        fontIcon='bi-person'
      >
        <SidebarMenuItem
          to='/menu/tandas/creartandas'
          title={intl.formatMessage({id: 'OPERACIONES.CREARTANDA'})}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/menu/tandas/aprobaciones'
          title={intl.formatMessage({id: 'OPERACIONES.APROBACIONES'})}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/menu/tandas/seguimientos'
          title={intl.formatMessage({id: 'OPERACIONES.SEGUIMIENTOS'})}
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>

      {/* ----REMESAS--- */}

      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        // title='Tandas'
        title={intl.formatMessage({id: 'MENU.OPERACION.REMESAS'})}
        icon='/media/icons/duotune/general/gen019.svg'
        fontIcon='bi-person'
        //16 19
      >
        <SidebarMenuItem
          to='/menu/remesas/cotizador'
          title={intl.formatMessage({id: 'OPERACION.REMESAS.COTIZADOR'})}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/menu/remesas/tipodecambio'
          title={intl.formatMessage({id: 'OPERACION.REMESAS.TIPOCAMBIO'})}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/menu/remesas/comisiones'
          title={intl.formatMessage({id: 'OPERACION.REMESAS.COMISIONES'})}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/menu/remesas/estatusremesas'
          title={intl.formatMessage({id: 'OPERACION.REMESAS.ESTATUSREMESAS'})}
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
            {intl.formatMessage({id: 'MENU.HERRAMIENTAS'})}
          </span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/herramientas/chat'
        // title='Chat'
        title={intl.formatMessage({id: 'HERRAMIENTAS.CHAT'})}
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/communication/com012.svg'
      >
        {/* <SidebarMenuItem
          to='/herramientas/chat/groupchat'
          title={intl.formatMessage({id: 'CHAT.GRUPOCHAT'})}
          hasBullet={true}
        /> */}
        <SidebarMenuItem
          to='/herramientas/chat/privatechat'
          title={intl.formatMessage({id: 'CHAT.PRIVATECHAT'})}
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/herramientas/invitaciones'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'HERRAMIENTAS.INVITACIONES'})}
        fontIcon='bi-layers'
      />
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>
            {intl.formatMessage({id: 'HERRAMIENTAS.AYUDA'})} {process.env.REACT_APP_VERSION}
          </span>
        </a>
      </div> */}
    </>
  )
}

export {SidebarMenuMain}
